<template>
  <div id="app">
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
      :opacity="1"
      color="#163e3c"
    />
    <layout>
      <template v-slot:header>
        <Header @goToSection="goToSection" />
      </template>
      <template v-slot:pages>
        <router-view :section="section" @finish="finish" />
      </template>
      <template v-slot:footer>
        <Footer @goToSection="goToSection" />
      </template>
    </layout>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import layout from '@/layouts/default.vue';
import Loading from 'vue-loading-overlay';
import Footer from './components/Footer.vue';
import Header from './components/Header.vue';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  name: 'App',
  data() {
    return {
      section: '',
      isLoading: false,
    };
  },
  computed: {
    ...mapGetters(['screenWidth', 'scrollY']),
  },
  components: {
    layout,
    Header,
    Footer,
    Loading,
  },
  metaInfo: {
    titleTemplate: '%sHS超集點',
    meta: [
      { charset: 'utf-8' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1' },

      {
        hid: 'description',
        name: 'description',
        content:
          'HS超集點是台灣唯一結合全方位生活美學領先體驗的紅利積點與會員服務，由漢齊科技整合國揚集團旗下之漢來大飯店、漢神百貨、漢來美食等核心產業。未來，將陸續提供更多跨產業、涵蓋生活相關的多樣特約商服務，提供消費累點與兌點等多樣性會員忠誠回饋機制，讓消費者有更自主、彈性、實用的點數運用與優惠選擇。快加入HS超集點享受最優惠的消費折抵、快速優先訂位、海港、漢來美食等餐券兌換及多種不定期的卡友禮、免費贈品等超值活動。',
      },
      { property: 'og:title', content: 'HS超集點' },
      { property: 'og:site_name', content: 'HS超集點' },
      { property: 'og:type', content: 'website' },
      { property: 'og:url', content: process.env.VUE_URL },
      { property: 'og:image', content: `${process.env.VUE_URL}img/share.png` },
      {
        property: 'og:description',
        content:
          'HS超集點是台灣唯一結合全方位生活美學領先體驗的紅利積點與會員服務，由漢齊科技整合國揚集團旗下之漢來大飯店、漢神百貨、漢來美食等核心產業。未來，將陸續提供更多跨產業、涵蓋生活相關的多樣特約商服務，提供消費累點與兌點等多樣性會員忠誠回饋機制，讓消費者有更自主、彈性、實用的點數運用與優惠選擇。快加入HS超集點享受最優惠的消費折抵、快速優先訂位、海港、漢來美食等餐券兌換及多種不定期的卡友禮、免費贈品等超值活動。',
      },
      {
        property: 'og:locale',
        content: 'zh_TW',
      },
      { property: 'twitter:title', content: '%sHS超集點' },
      { property: 'twitter:url', content: process.env.VUE_URL },
      {
        property: 'twitter:description',
        content:
          'HS超集點是台灣唯一結合全方位生活美學領先體驗的紅利積點與會員服務，由漢齊科技整合國揚集團旗下之漢來大飯店、漢神百貨、漢來美食等核心產業。未來，將陸續提供更多跨產業、涵蓋生活相關的多樣特約商服務，提供消費累點與兌點等多樣性會員忠誠回饋機制，讓消費者有更自主、彈性、實用的點數運用與優惠選擇。快加入HS超集點享受最優惠的消費折抵、快速優先訂位、海港、漢來美食等餐券兌換及多種不定期的卡友禮、免費贈品等超值活動。',
      },
      { property: 'twitter:image', content: `${process.env.VUE_URL}img/share.png` },
    ],
    htmlAttrs: {
      lang: 'zhTW',
    },
  },
  methods: {
    ...mapActions(['update_width', 'update_scroll', 'update_wrap']),
    handleResize() {
      this.update_width(window.innerWidth);
    },
    handleScroll() {
      this.update_scroll(window.scrollY);
    },
    goToSection(section) {
      this.section = section;
    },
    finish() {
      this.section = '';
    },
  },
  mounted() {
    const vm = this;
    window.onresize = () => (() => {
      window.screenWidth = document.body.clientWidth;
      vm.update_width(window.screenWidth);
    })();
    window.onscroll = () => (() => {
      if (window.scrollY > 0) {
        vm.update_scroll(window.scrollY);
        vm.update_wrap(document.getElementsByClassName('row')[0].offsetHeight);
      }
    })();
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize);
    window.removeEventListener('scroll', this.handleScroll);
  },
  watch: {
    screenWidth(val) {
      this.update_width(val);
    },
    scrollY(val) {
      this.update_scroll(val);
    },
    wrapH(val) {
      this.update_wrap(val);
    },
    $route() {
      this.isLoading = true;
      this.update_wrap(0);
      setTimeout(() => {
        this.isLoading = false;
      }, 700);
    },
  },
};
</script>
<style lang="scss">
@import url('https://fonts.googleapis.com/css?family=Noto+Sans+TC:100,300,400,500,700,900&display=swap&subset=chinese-traditional,latin-ext');
#app {
  .v-enter-active,
  .v-leave-active {
    transition-duration: 0.3s;
    transition-property: opacity;
    transition-timing-function: ease-in;
  }
  .v-enter,
  .v-leave-active {
    opacity: 0;
  }
}
</style>
